import { Module, getModule, VuexModule, MutationAction, Mutation } from 'vuex-module-decorators';
import store from '@/store';
import { FilterRequestType } from '@/entity/common/filters.types'
import { IProductsUnitItem } from '@/entity/warehouse/Products/Unit/Unit.types'
import { prepareFormData } from '@/store/utils/formDataHelper'

@Module({
    namespaced: true,
    name: 'ProductsUnit',
    store,
    dynamic: true
})
class ProductsUnitModule extends VuexModule {
    public productsUnit:IProductsUnitItem[] | null = null
    ready = false

    @MutationAction
    async fetchAll(data?: FilterRequestType): Promise<{ productsUnit:IProductsUnitItem[]}>{
        const productsUnit = await store.$repository.products_unit.fetchAll(prepareFormData(data));
        return { productsUnit }
    }
    @Mutation
    async setReady(st:boolean){
        this.ready = st
    }

}
export const ProductsUnitStore = getModule(ProductsUnitModule)